import { useRef, useEffect } from "react";
import rangy from "rangy";
import "rangy/lib/rangy-classapplier";

export const Test = () => {

  function highlightSelection() {
    const selection = rangy.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);

    if (range.collapsed) return;

    // Create a class applier for highlighting
    const classApplier = rangy.createClassApplier("highlight", {
      elementTagName: "span",
      elementAttributes: {
        style: "background-color: yellow;",
      },
      normalize: true,
    });

    classApplier.applyToRange(range);

    // Clear the selection
    selection.removeAllRanges();
  }

  const process = () => {
    const selection = rangy.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const source = document.querySelector(".selectable") as HTMLElement;
    const result = document.querySelector(".result pre") as HTMLElement;

    const initialHtml = source.innerHTML;
    highlightSelection();
    result.innerHTML = source.innerHTML;
    source.innerHTML = initialHtml;

    // Create a class applier for
  }
  const mainHtml = useRef<HTMLDivElement>(null);

  return (
    <div className={"flex gap-2 w-full"}>
      <div
        className="flex selectable border p-2 border-gray-1"
        ref={mainHtml}
        onMouseUp={process}
      >
        <div>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
          <img src={"https://picsum.photos/200/300"} alt="Sample" />
          <ul>
            <li>List item 1</li>
            <li>List item 2</li>
          </ul>
        </div>
      </div>
      <div className="flex result border p-2 border-gray-1">
        <pre></pre>
      </div>
    </div>
  );
};